<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'
import { stat } from 'fs';

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
    },
    methods:{
        filter: function(){
            let state = this;
            state.items = [];
            $('#spinner').modal('toggle');
            this.filters.status='ACTIVE';
            Request.do(state, 'POST', Request.getDefaultHeader(state), this.filters, `${Endpoints.companies.filter}`,
            (response)=>{//SUCCESS CALLBACK
                state.items = response.results[0].paginatedResults;                
                $('#spinner').modal('toggle');
            },
            (error)=>{//ERROR CALLBACK
                console.log(error);
            });
           
        },
        onChangePage(pageOfItems) {
            // update page of items
            this.pageOfItems = pageOfItems;
        },
        selectItem: function(item){
            this.$emit('load-item', item);
        },
        getPageNumbers: function(){
            return this.items.length/10;
        },
        fetchData(){
            this.json_data = this.items;
            return this.json_data;
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
